
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { Bar } from "vue-chartjs";

@Component({
  extends: Bar
})
export default class SalesReportChart extends Mixins(Bar) {
  @Prop({ required: true }) data!: number[];
  @Prop({ required: true }) purchaseData!: number[];
  @Prop({ required: true }) profitabilityData!: number[];
  @Prop({ required: true }) labels!: string[];

  mounted() {
    // 印刷時に黒塗りになってしまうのを防ぐ
    this.addPlugin({
      id: "custom-background-color",
      beforeDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });
    this.init();
  }

  @Watch("chartData")
  private init() {
    this.renderChart(this.chartData, {
      responsive: true,
      animation: { duration: 100 },
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "金額(100万円)",
              fontSize: 16
            },
            id: "left-y-axis",
            ticks: {
              suggestedMax: 100000,
              suggestedMin: 0,
              stepSize: 100000,
              maxTicksLimit: 8,
              callback(value) {
                return `${value / 1000000}`;
              }
            }
          },
          {
            scaleLabel: {
              display: true,
              labelString: "利益率",
              fontSize: 16
            },
            id: "right-y-axis",
            position: "right",
            ticks: {
              suggestedMax: 100,
              suggestedMin: 0,
              stepSize: 10,
              maxTicksLimit: 8,
              callback(value) {
                return `${value}%`;
              }
            }
          }
        ]
      },
      tooltips: {
        callbacks: {
          label(item) {
            const formatter = Intl.NumberFormat("ja-JP", {
              style: "currency",
              currency: "JPY"
            });
            return formatter.format(Number(item.value!));
          }
        }
      }
    });
  }

  private get chartData() {
    return {
      labels: this.labels,
      datasets: [
        {
          label: "利益率",
          type: "line",
          borderColor: "#F7B035",
          fill: false,
          data: this.profitabilityData,
          lineTension: 0,
          yAxisID: "right-y-axis"
        },
        {
          label: "請求総額",
          data: this.data,
          yAxisID: "left-y-axis"
        },
        {
          label: "発注総額",
          backgroundColor: "#2196F3",
          fill: false,
          data: this.purchaseData,
          yAxisID: "left-y-axis"
        }
      ]
    };
  }
}
